import React from "react";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { commonStyles } from "../../../../theme/commonStyles";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import SvgIcon from "react-icons-kit";
import { circle } from "react-icons-kit/fa/circle";
import { ic_arrow_back } from "react-icons-kit/md/ic_arrow_back";
export const MaintenanceDetailHeaderView = ({ mainTitle }) => {
  return (
    <Row style={{ borderBottom: "2px solid #d1d1d1", margin: "0px 30px", padding: "10px 0px" }}>
      <Col md="6" style={{ paddingLeft: "0px" }}>
        <div style={themeService(commonStyles.pageTitleDetailStyle)}>
          <Link to="/maintenancebacklog" className="linkStyleTable">
            <SvgIcon
              size={25}
              icon={ic_arrow_back}
              style={{ marginRight: "5px", marginLeft: "5px", verticalAlign: "middle", cursor: "pointer" }}
            />
          </Link>
          <SvgIcon size={12} icon={circle} style={{ marginRight: "10px", marginLeft: "5px" }} />
          {mainTitle}
        </div>
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/DetailViews/MaintennaceDetailHeaderView.jsx